import { useRef } from 'react';
import { isEqual } from 'lodash';

const defaultCompare = (prev, current) => {
	//eslint-disable-next-line
	if (typeof prev !== typeof current) return prev == current;
	if (typeof current === 'object' || typeof prev === 'object')
		return isEqual(prev, current);
	else return prev === current;
};

const usePrev = (value, compare = defaultCompare) => {
	const ref = useRef({
		value,
		prev: null
	});

	const currentValue = ref.current.value;
	if (compare(value, currentValue)) {
		ref.current = {
			value,
			prev: currentValue
		};
	}

	return ref.current.prev;
};

export default usePrev;
